import { TradeSubTradeItem } from 'app/models/trade-sub-trade-params'
import { createReducer } from 'app/state/utils'
import * as types from './types'

export interface TradeSubTradesState {
  /** One trade's sub trades, by master trade id — what its expanded row shows. */
  byMasterTrade: Record<string, TradeSubTradeItem[]>
  loadingByMasterTrade: Record<string, boolean>
  /** Trades whose last read failed; cleared when a read starts or lands. */
  failedByMasterTrade: Record<string, boolean>
}

const initialState: TradeSubTradesState = { byMasterTrade: {}, loadingByMasterTrade: {}, failedByMasterTrade: {} }

const without = (map: Record<string, boolean> | undefined, key: string) => {
  const next = { ...map }
  delete next[key]
  return next
}

/**
 * READ-only, per trade: a row expand fetches that trade's sub trades and
 * keeps them under its id; expanding it again fetches again (the read is one
 * small statement), so a write on the trade is never stale here.
 */
const tradeSubTradesReducer = createReducer(initialState)({
  [types.GET_TRADE_SUB_TRADES]: (
    state: TradeSubTradesState,
    action: { payload: { masterTradeId: string; items: TradeSubTradeItem[] } },
  ) => ({
    ...state,
    byMasterTrade: { ...state.byMasterTrade, [action.payload.masterTradeId]: action.payload.items },
    failedByMasterTrade: without(state.failedByMasterTrade, action.payload.masterTradeId),
  }),
  [types.START_LOADING_TRADE_SUB_TRADES]: (
    state: TradeSubTradesState,
    action: { payload: { masterTradeId: string } },
  ) => ({
    ...state,
    loadingByMasterTrade: { ...state.loadingByMasterTrade, [action.payload.masterTradeId]: true },
    failedByMasterTrade: without(state.failedByMasterTrade, action.payload.masterTradeId),
  }),
  [types.STOP_LOADING_TRADE_SUB_TRADES]: (
    state: TradeSubTradesState,
    action: { payload: { masterTradeId: string } },
  ) => {
    const loadingByMasterTrade = { ...state.loadingByMasterTrade }
    delete loadingByMasterTrade[action.payload.masterTradeId]
    return { ...state, loadingByMasterTrade }
  },
  [types.FAIL_TRADE_SUB_TRADES]: (
    state: TradeSubTradesState,
    action: { payload: { masterTradeId: string } },
  ) => ({
    ...state,
    failedByMasterTrade: { ...state.failedByMasterTrade, [action.payload.masterTradeId]: true },
  }),
})

export default tradeSubTradesReducer
